import { render } from "./PermissionsIcon.vue?vue&type=template&id=5377cacb"
const script = {}

import exportComponent from "/Users/dharmik/www/pfizer-invoicing-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__